// Shared, in-memory signal for which docked chat surface owns chat on the
// current page. Code-view publishes into this store once it knows whether the
// page is a file view or the repo overview. The embedded Copilot panel reads it
// to decide whether to auto-reopen on hard load, instead of guessing from the
// URL or racing a fixed timeout.
//
// The store is written and read only from client effects, so it never runs
// during server rendering and cannot leak state across SSR requests.

// A resolved docked surface. 'code-view' means the code-view side panel owns
// chat. 'none' means the page has no docked surface (for example the overview).
export type DockedChatSurface = 'code-view' | 'none'

// `undefined` means code-view has not resolved the page yet.
let currentSurface: DockedChatSurface | undefined
const listeners = new Set<() => void>()

export function getDockedChatSurface(): DockedChatSurface | undefined {
  return currentSurface
}

export function publishDockedChatSurface(surface: DockedChatSurface): void {
  if (currentSurface === surface) return
  currentSurface = surface
  notify()
}

export function clearDockedChatSurface(): void {
  if (currentSurface === undefined) return
  currentSurface = undefined
  notify()
}

export function subscribeDockedChatSurface(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function notify(): void {
  for (const listener of listeners) {
    listener()
  }
}
